import React, { useRef, useState, useEffect } from 'react'
import Translate from "../../../../../../../components/Translate";
import colors from "../../../../../../../utils/Colors";
import SilverButton from "../../../../../../../components-new/buttons/SilverButton";
import PlusIcon from "../../../../../../../assets/icons/PlusIcon";
import GripVerticalIcon from "../../../../../../../assets/icons/GripVerticalIcon";
import NodeEditorButton from "../components/NodeEditorButton";
import CircleAlertIcon from "../../../../../../../assets/icons/CircleAlertIcon";

const Buttons = ({ buttons, setButtons, addButton, addButtonOnMount = false, showWhatsappNotice = false }) => {
    const containerRef = useRef(null);
    const [dragIndex, setDragIndex] = useState(null);
    const [dragY, setDragY] = useState(0);
    const [startY, setStartY] = useState(0);
    const [focusedIndex, setFocusedIndex] = useState(null);

    const handleMouseDown = (e, index) => {
        setDragIndex(index);
        setStartY(e.clientY);
        e.preventDefault();
    };

    const handleMouseMove = (e) => {
        if (dragIndex === null) return;
        const delta = e.clientY - startY;
        setDragY(delta);
    };

    const handleMouseUp = () => {
        if (dragIndex === null) return;

        const delta = dragY;
        let newButtons = [...buttons];

        if (Math.abs(delta) > 50) {
            const direction = delta < 0 ? -1 : 1;
            const targetIndex = dragIndex + direction;

            if (targetIndex >= 0 && targetIndex < buttons.length) {
                [newButtons[dragIndex],newButtons[targetIndex]] = [newButtons[targetIndex],newButtons[dragIndex]];
                setButtons(newButtons);
            }
        }

        setDragIndex(null);
        setDragY(0);
        setStartY(0);
    };

    useEffect(() => {
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    });

    useEffect(() => {
        if(addButtonOnMount){
            addButton(true)
        }
    }, []);

    return (
        <div className="control-section border-bottom buttons-section" ref={containerRef}>
            <h2 className="heading" style={{fontSize: '14px',color: colors.silverBlue, fontWeight: 'normal'}}>
                <Translate text="addButtonDescription"/>
                <br/>
                {showWhatsappNotice && (
                    <div
                        style={{
                            display: 'flex',
                            gap:'8px',
                            background: colors.yellowExtraLite,
                            border: `1px solid ${colors.yellow}`,
                            color: colors.yellowExtraDark,
                            padding: '8px 12px',
                            borderRadius: '6px',
                            fontSize: '12px',
                            marginTop: '8px'
                        }}
                    >
                        <CircleAlertIcon height={16} width={16} style={{flexShrink: 0, transform: 'translateY(2px)'}}/>
                        <Translate text="whatsappButtonsWarning" />
                    </div>
                )}
            </h2>

            <ul
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    padding: '6px',
                    margin: '16px -6px 4px -6px',
                    overflowY: 'auto',
                    overflowX: 'visible',
                    maxHeight: '400px',
                    position: 'relative',
                }}
            >
                {buttons.length > 0 ? (
                    buttons.map((button, index) => {

                        const isDragging = dragIndex === index;
                        const isFocused = focusedIndex === index;

                        const transformY = isDragging ? `translateY(${dragY}px)` : 'none';
                        const zIndex = isDragging ? 10 : isFocused ? 2000 : 0;
                        const transition = isDragging ? 'none' : 'transform 0.2s ease';

                        return (
                            <div
                                key={button.id}
                                style={{
                                    display: 'flex',
                                    gap: '8px',
                                    alignItems: 'center',
                                    transform: transformY,
                                    zIndex,
                                    transition,
                                    position: 'relative',
                                }}
                                tabIndex={0}
                                onClick={() => setFocusedIndex(index)}
                                onFocus={() => setFocusedIndex(index)}
                                onBlur={() => setFocusedIndex(null)}
                            >
                                {buttons.length > 1 && (
                                    <GripVerticalIcon
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        onMouseDown={(e) => handleMouseDown(e, index)}
                                        style={{cursor: 'grab', color: colors.silverBlueExtraLite}}
                                        width={18}
                                    />
                                )}

                                <NodeEditorButton
                                    text={button.shortText}
                                    link={button.link}
                                    onDelete={() => {
                                        setButtons(buttons.filter((_, i) => i !== index));
                                    }}
                                    onSave={(val) => {
                                        setButtons(buttons.map((b, i) => (i === index ? {...b,shortText:val,text:[val,b.link].join('||')} : b)));
                                    }}
                                    onLinkSave={(val) => {
                                        setButtons(buttons.map((b, i) => (i === index ? {...b,link:val} : b)));
                                    }}
                                    defaultEditable={button.shortText === '' || button.defaultEditable}
                                    style={{flexGrow: 1}}
                                    buttonVariants={'outline'}
                                    /*popupDirection={index === buttons.length - 1 && index !== 0 ? 'top' : 'bottom'}*/
                                    popupDirection={'left'}
                                />
                            </div>
                        );
                    })
                ) : (
                    <span
                        style={{
                            margin: '20px 0',
                            color: colors.silverBlueLite,
                            fontSize: '14px',
                            fontWeight: 'normal',
                            textAlign: 'center',
                        }}
                    >
                        <Translate text="noButtons" />
                    </span>
                )}
            </ul>

            <SilverButton
                onClick={() => {
                    if ((buttons[buttons.length - 1] && buttons[buttons.length-1].shortText) !== '' || buttons.length === 0) addButton();
                }}
                styles={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    color: colors.silverDark,
                    fontSize: '14px',
                }}
            >
                <PlusIcon style={{color: colors.silverDark}} stroke="currentColor" width={18} height={18} />
                <Translate text="addButton" />
            </SilverButton>
        </div>
    );
};

export default Buttons;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/NodeEditor/partials/Buttons.jsx